<!-- App Main Structure -->
<template>
    <div class="app-default-layout">
        <template v-if="loading">
            <loader :fullScreen="true" />
        </template>
        <template v-else>
            <!-- App Header -->
            <app-header :authenticated="authenticated" :auth="auth" :coronerUserDto="coronerUserDto" :authProfile="authProfile"></app-header>
            <!-- App Main Content -->
            <v-content>
                <!-- App Router -->
                <v-alert class="errorMessages" :value="errorList.length > 0" color="error">
                    <v-layout row align-bottom style="margin-bottom: 10px;">
                        <div class="subheading" style="align-self: flex-end;">Errors have occurred</div>
                        <v-spacer></v-spacer>
                        <v-btn style="margin: 0px;" icon @click="errorMessageClear()"><v-icon color="white">cancel</v-icon></v-btn>
                    </v-layout>
                    <div class="" style="margin-left: 5px;">
                        <div v-for="error in errorList" v-bind:key="error.id" style="max-width: 260px; margin-bottom: 10px; border-bottom: 1px solid;">
                            {{ error.time }}<br/>
                            {{ error.status }}{{ error.message }}<br/>
                            {{ error.url }}<br/>
                        </div>
                    </div>
                </v-alert>
                <transition name="router-anim" :enter-active-class="`animated ${selectedRouterAnimation}`">
                    <router-view :key="routeViewKey" :auth="auth" :coronerUserDto="coronerUserDto" :authProfile="authProfile"></router-view>
                </transition>
                <div v-if="isDebug" style="margin: 20px;">
                    <h4>DEBUG</h4>
                    <div>App Idle: {{isAppIdle}}</div>
                </div>
                <time-out-modal :auth="auth" :authenticated="authenticated" />
            </v-content>
        </template>
    </div>
</template>

<script>
import loader from '@/components/Loader.vue'
import loggingService from '@/services/util/loggingService'
import dateService from '@/services/util/dateService'
import userService from '@/services/userService'
import { mapState, mapGetters } from 'vuex'
import Header from '@/components/Header/Header.vue'
import timeOutModal from '@/components/TimeoutModal.vue'
import AuthService from '@/auth/AuthService'

const auth = new AuthService()
const { authNotifier, renewTokens } = auth

export default {
    name: 'Container-Full',
    data () {
        authNotifier.on('authChange', authState => {
            this.authenticated = authState.authenticated
            if (authState.authenticated) {
                loggingService.log(this.isDebug, 'Full.vue - authNotifier', ' authenticated')
                //this.loading = true
                this.$store.dispatch('authenticated', authState.authResult).then(
                    val => {
                        //this.loading = false
                        this.onAuthenticated('New')
                        //set interval to renew token
                        let expiredAtMs = JSON.parse(localStorage.getItem('expires_at') - new Date().getTime())
                        loggingService.log(this.isDebug, 'Full.vue - Expire At', `session will expire in ${expiredAtMs / 1000} seconds`)
                        if (expiredAtMs > 0) {
                            let renewTimer = expiredAtMs - 120000 > 0 ? expiredAtMs - 120000 : 60000
                            loggingService.log(this.isDebug, 'Full.vue - Renew Timer', `renew timer set in ${renewTimer / 1000} seconds`)
                            setTimeout(() => {
                                loggingService.log(this.isDebug, 'Full.vue', `renew timer triggered`)
                                if (this.isAppIdle) {
                                    loggingService.log(this.isDebug, 'Full.vue', `user is idle, logging out...`)
                                    this.auth.logout()
                                } else {
                                    loggingService.log(this.isDebug, 'Full.vue', `user is active, renew token...`)
                                    this.auth.renewTokens()
                                }
                            }, renewTimer)
                        }
                    },
                    err => {
                        //this.loading = false
                        console.log('dispatch.then error: ' + err)
                    }
                )
                this.$store.commit('clearErrors')
            } else {
                loggingService.log(this.isDebug, 'Full.vue - authNotifier', ' not authenticated')
                this.$store.dispatch('logout')
            }
        })
        return {
            loading: true,
            isDebug: false,
            auth,
            authenticated: false
        }
    },
    components: {
        appHeader: Header,
        timeOutModal,
        loader
    },
    computed: {
        ...mapGetters(['selectedRouterAnimation', 'coronerUserDto', 'authProfile']),
        ...mapState({
            httpRunning: state => state.httpRunning,
            errorList: state => state.errorList
        }),
        routeViewKey () {
            return this.$route.fullPath
        }
    },
    mounted () {
        this.loading = false
    },
    async created () {
        try {
            await renewTokens()
        } catch (e) {
            loggingService.log(this.isDebug, 'Full.vue - created', 'renewToken - error')
            loggingService.logRaw(this.isDebug, e)
        }
        //on container create, check user auth
        // if (this.auth.isAuthenticated()) {
        //     loggingService.log(this.isDebug, 'Full.vue', 'On Create - authenticated')
        //     this.$store.dispatch('authenticated').then(
        //         val => { this.onAuthenticated('New') },
        //         err => { console.log('dispatch.then error: ' + err) }
        //     )
        //     this.$store.commit('clearErrors')
        // } else {
        //     loggingService.log(this.isDebug, 'Full.vue', 'On Create - not authenticated')
        //     this.$store.dispatch('logout')
        // }
    },
    methods: {
        onAuthenticated (type) {
            loggingService.log(this.isDebug, 'Full.vue', 'onAuthenticated - ' + type + ' - ' + dateService.toStringNow())
            var result = userService.validate(this.profile, this.coronerUserDto.roleList, this.coronerUserDto.userCountyList)
            //console.log(result)
            if (!result.isValid) {
                this.$router.push('/userprofile')
            }
        },
        errorMessageClear () {
            this.$store.commit('clearErrors')
        }
    }
}
</script>

<style scoped>
    .app-default-layout {
        height: 100vh
    }
    .errorMessages {
        position: fixed;
        right: 0;
        width: 300px;
        border: 2px solid;
        z-index: 9999;
        margin-top: 10px;
        margin-right: 30px;
    }
</style>
